import Helper from '../helpers/Helper';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

export default class Form {
    constructor() {
        this.el = null;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;
        this.bindForm();
    }
    bindForm() {
        this.el.querySelector('.contactform__form').addEventListener('submit', (e) => {
            e.preventDefault();
            let form = e.target;
            form.querySelector('.contactform__submit').disabled = true;
            if (form.querySelector('.contactform__response') !== null) {
                form.querySelector('.contactform__response').remove();
            }
            let data = new FormData(form),
                request = new XMLHttpRequest();
            request.onreadystatechange = () => {
                if (request.readyState <= 3) {
                    return;
                }
                let response_type;
                if (request.status == 200) {
                    form.reset();
                    response_type = 'success';
                } else {
                    response_type = 'error';
                }
                let response_text = JSON.parse(request.responseText).public_message;
                form.insertAdjacentHTML(
                    'afterbegin',
                    `<div class="contactform__response contactform__response--${response_type}">
                                        ${response_text}
                                    </div>`
                );
                form.querySelector('.contactform__submit').disabled = false;

                this.getContainer().scroll({
                    top: this.offsetTop(document.querySelector('.contactform__response')) - 50,
                    left: 0,
                    behavior: 'smooth'
                });
            };
            request.open(form.method, form.action);
            request.send(data);
        });
    }
    offsetTop(el) {
        let val;
        if (this.getContainer() !== window) {
            // offset of element inside container
            val =
                el.getBoundingClientRect().top +
                this.getContainer().scrollTop -
                document.documentElement.clientTop;
            // offset of container
            val -=
                this.getContainer().getBoundingClientRect().top +
                window.pageYOffset -
                document.documentElement.clientTop;
        } else {
            val =
                el.getBoundingClientRect().top +
                window.pageYOffset -
                document.documentElement.clientTop;
        }
        return val;
    }
    getContainer() {
        let container;
        if (Helper.isInsideEditor()) {
            container = document.querySelector('.page-wrap');
        } else {
            container = window;
        }
        return container;
    }
}
